<ng-container *ngIf="!loading">
  <ng-container>
    <div class="modal-container">
      <div class="modal-header">
        <h4 class="modal-title">{{ videoData.videoTitle }}</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="closeModal()"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">
        <div class="player">
          <iframe
            *ngIf="videoData.embedUrl"
            width="100%"
            height="100%"
            [src]="videoData.embedUrl"
            frameborder="0"
            sandbox="allow-scripts allow-same-origin allow-presentation"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div class="modal-footer">
        <div class="modal-description" *ngIf="videoData.videoSubtitle">
          <p class="description-text">
            {{ isExpanded ? videoData.videoSubtitle : truncatedSubtitle }}
          </p>
          <button
            *ngIf="videoData.videoSubtitle.length > 100"
            class="show-more-btn"
            (click)="showMoreSubtitle()"
          >
            {{ isExpanded ? 'Mostrar menos' : 'Mostrar mais' }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
